export const selectCountryList = {
	list: (state) => state.utils.country_list.list,
	fetch: (state) => state.utils.country_list.fetch,
	params: (state) => state.utils.country_list.params,
};
